import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modern-schooling-events',
  templateUrl: './modern-schooling-events.component.html',
  styleUrls: ['./modern-schooling-events.component.scss']
})
export class ModernSchoolingEventsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
